import {
  UserSortBy,
  UserSubaccountRole,
  UserTenantRole,
} from "~frontend/__generated__/graphql";

export const USER_SORTS = [
  { value: UserSortBy.FullNameAsc, label: "Name, A-Z" },
  { value: UserSortBy.FullNameDesc, label: "Name, Z-A" },
  { value: UserSortBy.CreatedAtDesc, label: "Joined At, Newest First" },
  { value: UserSortBy.CreatedAtAsc, label: "Joined At, Oldest First" },
];

export const USER_INVITE_SORTS = [
  { value: UserSortBy.FullNameAsc, label: "Name, A-Z" },
  { value: UserSortBy.FullNameDesc, label: "Name, Z-A" },
  { value: UserSortBy.CreatedAtDesc, label: "Invited At, Newest First" },
  { value: UserSortBy.CreatedAtAsc, label: "Invited At, Oldest First" },
];

export const SUBACCOUNT_ROLE_DISPLAY_NAMES: {
  [role in UserSubaccountRole]: string;
} = {
  [UserSubaccountRole.Admin]: "Admin",
  [UserSubaccountRole.Supervolunteer]: "Supervolunteer",
  [UserSubaccountRole.Texter]: "Texter",
};

export const TENANT_ROLE_DISPLAY_NAMES: {
  [role in UserTenantRole]: string;
} = {
  [UserTenantRole.None]: "None",
  [UserTenantRole.Owner]: "Organization Owner",
  [UserTenantRole.ApiKey]: "API Key",
  [UserTenantRole.Staff]: "Scale to Win Staff",
};
